/*
 * Parent application
 * Defines the application module and route configuration
 */

angular
  .module('sms.parent', [
    'sms.parent.controllers',
    'sms.parent.services',
    'ui.bootstrap.showErrors',
    'ui.router'
  ])

  .config(function ($stateProvider, $urlRouterProvider) {
    $urlRouterProvider.otherwise('/')
    $stateProvider.state('main', {
      url: '/',
      templateUrl: 'partials/main.html',
      controller: 'mainController'
    })
  })
